import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NotificationService } from '../../../../services/notification.service';
import { CreditHealthService } from '../../services/credit-health.service';
import { AccountsState } from '../../../accounts/store/accounts.reducer';
import { selectAccountsState, selectGatewayError } from 'src/app/feature-modules/accounts/store/accounts.selector';
import {
  selectCreditHealthError,
  selectCreditHealth200Error,
  selectCreditHealth,
} from '../../store/credit-health.selector';
import { BEFH_ERROR_MARKUP } from '../../../../config/accountErrors.config';

@Component({
    selector: 'app-credit-health',
    templateUrl: './credit-health.component.html',
    styleUrls: ['./credit-health.component.scss'],
    standalone: false
})
export class CreditHealthComponent implements OnInit, OnDestroy {
  creditHealthState$ = this.store.select(selectCreditHealth);
  creditHealthError$ = this.store.select(selectCreditHealthError);
  creditHealth200Error$ = this.store.select(selectCreditHealth200Error);
  gatewayError$ = this.store.select(selectGatewayError);
  accountState$ = this.store.select(selectAccountsState);

  isBefhError: boolean;
  befhUrl: string;
  isCreditScoreAvailable: boolean;
  mostRecentCreditScore: number;

  private readonly ngUnsubscribe$: Subject<boolean> = new Subject();

  constructor(
    private readonly store: Store,
    private readonly creditHealthService: CreditHealthService,
    private readonly notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    combineLatest([
      this.creditHealthState$,
      this.accountState$,
      this.creditHealthError$,
      this.creditHealth200Error$,
      this.gatewayError$,
    ])
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(([creditHealthState, accountState, creditHealthError, creditHealth200Error, gatewayError]) => {
        this.isCreditScoreAvailable =
          accountState.accounts.bechAccounts[0]?.enrolled &&
          accountState.accounts.bechAccounts[0]?.kbaCompleted &&
          !creditHealthError &&
          !creditHealth200Error &&
          !gatewayError;

        // TODO: verify if showing the "Get my credit score" version is desired if no data here
        if (creditHealthState?.latest_score) {
          this.mostRecentCreditScore = creditHealthState.latest_score;
        } else {
          this.isCreditScoreAvailable = false;
        }

        this.befhUrl = accountState.accounts.bechAccounts[0]?.url;
      });
  }

  onNavigateToMoneyManager() {
    this.creditHealthService.navigateToCreditHealthMoneyManager(this.befhUrl);
  }

  onNavigateToDebtManager() {
    this.creditHealthService.navigateToCreditHealthDebtManager(this.befhUrl);
  }

  onNavigateToBEFH() {
    if (!this.befhUrl) {
      this.notificationService.displayCustomErrorSnackbar(BEFH_ERROR_MARKUP);
      return;
    }
    this.creditHealthService.navigateToCreditHealth(this.befhUrl);
  }

  ngOnDestroy() {
    this.ngUnsubscribe$.next(null);
    this.ngUnsubscribe$.complete();
  }
}
